import { render, staticRenderFns } from "./DsFormContent.vue?vue&type=template&id=24734952&scoped=true"
import script from "./DsFormContent.vue?vue&type=script&lang=js"
export * from "./DsFormContent.vue?vue&type=script&lang=js"
import style0 from "./DsFormContent.vue?vue&type=style&index=0&id=24734952&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24734952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24734952')) {
      api.createRecord('24734952', component.options)
    } else {
      api.reload('24734952', component.options)
    }
    module.hot.accept("./DsFormContent.vue?vue&type=template&id=24734952&scoped=true", function () {
      api.rerender('24734952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsFormContent.vue"
export default component.exports